export const SET_LOCALE = 'SET_LOCALE';
export const GET_REGIONS = 'GET_REGIONS';
export const SET_ACTIVE_POI = 'SET_ACTIVE_POI';
export const SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE';
export const SET_PREVIOUS = 'SET_PREVIOUS';